import Vue from "vue";
import VueRouter from "vue-router";
import Authentication from "./Authentication.router";
import user from "./user.router";
import Content from "./Content.router";

Vue.use(VueRouter);

export default new VueRouter({
  mode: "history",
  routes: [Authentication, Content, user]
});
